module.exports = __webpack_public_path__ + "static/media/step-2.64854696.svg";